import { getQueryString, setAccountStorage, setTokenStorage } from './../../../utils/index';
/*
 * @Author: your name
 * @Desc:
 */
import { observable, action, runInAction } from "mobx";
import { getLabel } from '@weapp/utils';
import { Dialog } from "@weapp/ui";

import * as API from "../../../api/pc/invite";
import { getTokenStorage } from "../../../utils";
import { loginAcceptParams } from "./type";
import { publicUrl } from "../../../constants";
import { ResetPass } from "../common/resetpass";

const { message } = Dialog;

export class InviteStore {

  @observable loginedUserVisible: boolean = false;//已登录账号显示人员信息还是输入框
  @observable loginVisible: boolean = false//已登录
  @observable joinKey: string = ''//邀请Key
  @observable signVerifyVisible: boolean = false;//显示账号校验
  @observable tenantName: string = '';//邀请团队名
  @observable loginUserName: string = '';//tgt未失效情况下当前用户信息
  @observable loginUserContact: string = '';//tgt未失效情况下当前用户信息

  @action
  changeLoginVisible = (visible: boolean) => {
    this.loginVisible = visible;
  }

  @action
  changeSignVerifyVisible = (visible: boolean) => {
    this.signVerifyVisible = visible;
  }

  @action
  changeLoginedUserVisible = (visible: boolean) => {
    this.loginedUserVisible = visible;
  }

  @action
  init = () => {
    this.joinKey = getQueryString('key') || '';

    API.checkLogin(this.joinKey).then((result: any) => {
      runInAction(() => {
        this.tenantName = result.data?.tenantName;
        if (result.data?.userInfo) {
          this.loginUserName = result.data.userInfo.username;
          this.loginUserContact = result.data.userInfo.mobile || result.data.userInfo.email;
          //如果是登录状态
          this.loginedUserVisible = true;
          this.loginVisible = true;
        }
        if (result.data?.userIdToken) {
          setTokenStorage(result.data?.userIdToken);
        }
        // 已经在团队的，直接登录
        if (result.data?.loginResult?.redirectUrl) {
          window.location.href = result.data.loginResult.redirectUrl;
        }
      })
    });
  }

  //当前是登录状态的，直接登录
  @action
  joinTenantByToken = () => {
    const params = {
      userIdToken: getTokenStorage(),
      joinKey: this.joinKey
    }
    // 这里在tsx步骤中需要保存account
    API.joinTenantByToken(params).then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result.data.errorMsg;
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        });
      } else {
        if (result.data?.redirectUrl) {
          window.location.href = result.data?.redirectUrl;
        } else {
          if (result.data?.hasTenant) {
            setAccountStorage(this.loginUserContact);
            setTokenStorage(result.userIdToken);
            window.location.href = `${publicUrl}/signup/tenant`;
          }
        }
      }
    });
  }


  //账号密码登录并接受
  @action
  loginAndAcceptJoin = (params: loginAcceptParams) => {

    API.loginAndAcceptJoin(params).then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result.data.errorMsg
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg)
        });
      } else {
        if (result.data?.redirectUrl) {
          window.location.href = result.data?.redirectUrl;
        } else {
          //管理员重置密码强制用户修改
          if (result?.data?.needPwdChange) {
            ResetPass.showDialog({ account: params.existAccount, oldPassword: params.existPassword }).then(() => {
              message({ type: "success", content: getLabel('154716', '修改成功，请重新登录') });
            });
            return;
          }
          // 无团队
          if (result.data?.hasTenant) {
            setAccountStorage(params.existAccount);
            setTokenStorage(result.userIdToken);
            window.location.href = `${publicUrl}/signup/tenant`
          }
        }
      }
    });
  }



}
const instance = new InviteStore();

export default instance;
export type InviteStoreType = Pick<InviteStore, keyof InviteStore>;
